export { pt } from '@payloadcms/translations/languages/pt'
